<template>

<v-dialog v-model="dialog" width="700px">
  <v-card>
    <p class=".title ma-2">Change the handling of the booking / option</p>
    <v-form ref="huovHandling">
      <br />
     <v-row class="ma-4">
       <v-col cols="4">
         <v-select v-model="huov.huov_handling_verk" :items="handling_codeKeuzes" item-value="handling_code" item-text="handling_oms" label="VFY handles Guest" dense></v-select>
       </v-col>
    
       <v-col cols="4">
         <v-select v-model="huov.huov_handling_ink" :items="handling_codeKeuzes" item-value="handling_code" item-text="handling_oms" label="VFY handles Host" dense></v-select>
       </v-col>
     </v-row>   

     <v-row class="ma-4">
       <v-col cols="4">
         
         <v-select
          v-model="huov.huov_review_send"
          :items="huov_review_sendKeuzes"
          item-value="code"
          item-text="desc"
          menu-props="auto"
          label="Send review to guest"
          :disabled="!huov.huov_update_send_review"
        ></v-select>
       </v-col>
    
       
     </v-row>   

    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      
      <v-btn color="primary mx-2"  small @click="updHuovHandling">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      huov_encrid: null,
      huov: {},
      handling_codeKeuzes: [],
      huov_review_sendKeuzes: [],
    }
  },
  methods: {
    open(huov_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/getHuovHandling.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuovHandling"
          },
          getHuovHandling: {
            huov_encrid: huov_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.getHuovHandling;
            res.data.getHuovHandling.handling_codeKeuzes.forEach(function(hand) {
               deze.handling_codeKeuzes.push(hand); 
            });
            res.data.getHuovHandling.huov_review_sendKeuzes.forEach(function (review) {
            deze.huov_review_sendKeuzes.push(review);
          });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updHuovHandling() { 
      this.$axios
        .post("ares/json/ares/huov/updHuovHandling.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updHuovHandling"
          },
          updHuovHandling: {
            huov_encrid: this.huov.huov_encrid,
            huov_handling_verk: this.huov.huov_handling_verk,
            huov_handling_ink: this.huov.huov_handling_ink,
            huov_review_send: this.huov.huov_review_send
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {      
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.updHuovHandling.text,
              color: res.data.updHuovHandling.color
             });
             if (res.data.updHuovHandling.color == "success" || res.data.updHuovHandling.color == "warning" ) {
              setTimeout(() => { this.$router.reload("/huov/onHuov/" + res.data.updHuovHandling.huov_encrid); }, 1000); 
            }
            this.dialog = false;
          }
        })
    },
  }
}
</script>

